import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9c0db412")

_pushScopeId("data-v-9c0db412")
const _hoisted_1 = { class: "loader" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock("section", {
    class: ["module", [ _ctx.module.type, { 'is-loading': _ctx.loading, 'is-view-more-active': _ctx.isViewMoreActive } ]]
  }, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_font_awesome_icon, {
        icon: "spinner",
        spin: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _createVNode("div", {
      id: `gallery-grid-${_ctx.module.id}`,
      class: "grid"
    }, [
      _createVNode("div", {
        id: `gallery-grid-sizer-${_ctx.module.id}`,
        class: "grid-sizer"
      }, null, 8, ["id"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visibleModuleImages, (image, index) => {
        return (_openBlock(), _createBlock("div", {
          class: ["grid-item", { 'is-after-view-more': (index + 1) > _ctx.module.moduleViewMoreMobileCutoff }],
          id: `gallery-module-${_ctx.module.id}-image-${index}`
        }, [
          _createVNode("img", {
            src: image.imageNsfw && !_ctx.appState.showNsfw ? image.galleryModuleInlineNsfwUrl : image.galleryModuleInlineUrl,
            alt: image.title,
            onClick: ($event: any) => (_ctx.onImageClick(index))
          }, null, 8, ["src", "alt", "onClick"])
        ], 10, ["id"]))
      }), 256))
    ], 8, ["id"]),
    (!_ctx.loading && _ctx.visibleModuleImages.length < _ctx.module.moduleImages.length && !_ctx.isViewMoreActive)
      ? (_openBlock(), _createBlock("a", {
          key: 0,
          class: "grid-item btn view-more-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onViewMoreClick && _ctx.onViewMoreClick(...args)))
        }, " View " + _toDisplayString(_ctx.module.moduleImages.length - _ctx.visibleModuleImages.length) + " More Images ", 1))
      : _createCommentVNode("", true)
  ], 2))
})